import { extractApiErrorMessage } from '../../helpers/apiErrorMessage'
import { QboCustomerRecord } from '../../domain/quickbooks/quickbooksModel'

export const filterQboCustomers = (customers: QboCustomerRecord[], search: string): QboCustomerRecord[] => {
  const term = search.trim().toLowerCase()
  if (!term) {
    return customers
  }
  return customers.filter(c =>
    c.displayName.toLowerCase().includes(term) || (c.companyName ?? '').toLowerCase().includes(term)
  )
}

export const toggleSelection = (selectedIds: string[], id: string): string[] =>
  selectedIds.includes(id) ? selectedIds.filter(s => s !== id) : [...selectedIds, id]

export const allSelected = (selectedIds: string[], visibleIds: string[]): boolean =>
  visibleIds.length > 0 && visibleIds.every(id => selectedIds.includes(id))

// "Select all" acts on what the search shows: it clears those rows when they are
// all selected, otherwise adds them. Selections hidden by the search are kept.
export const toggleSelectAll = (selectedIds: string[], visibleIds: string[]): string[] =>
  allSelected(selectedIds, visibleIds)
    ? selectedIds.filter(id => !visibleIds.includes(id))
    : [...selectedIds, ...visibleIds.filter(id => !selectedIds.includes(id))]

// The import posts whole QuickBooks records, picked from the full list rather than
// the filtered one so a selection hidden by the current search is still imported.
export const selectedQboCustomers = (customers: QboCustomerRecord[], selectedIds: string[]): QboCustomerRecord[] =>
  customers.filter(c => selectedIds.includes(c.id))

// The import's BadRequest body is a plain string listing the failures; every other
// error (e.g. "You are not connected to QuickBooks") uses the shared API error shape.
export const qboImportErrorMessage = (error: unknown, fallback: string): string => {
  const data = (error as { response?: { data?: unknown } })?.response?.data
  if (typeof data === 'string' && data.trim()) {
    return data.trim()
  }
  return extractApiErrorMessage(error, fallback)
}

// Selected rows the current search hides; they are still imported, so the dialog says so.
export const hiddenSelectionCount = (selectedIds: string[], visibleIds: string[]): number =>
  selectedIds.filter(id => !visibleIds.includes(id)).length
